<template>
  <div class="icon-card">
    <div class="icon-card__icon">
      <ErrorIcon
        v-if="type === 'warn' || type === 'succes'"
        :class="{
          'icon--warn': type === 'warn',
          'icon--succes': type === 'succes'
        }"
        customColor
      />
      <TestsIcon v-else />
    </div>
    <slot></slot>
  </div>
</template>
<script>
import TestsIcon from '@/assets/icons/tests'
import ErrorIcon from '@/assets/icons/error'

export default {
  name: 'icon-card',
  components: { TestsIcon, ErrorIcon },
  props: ['type']
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
